export class Modal {
  constructor() {
    this.container = document.querySelector('[data-modal]');
    this.triggers = document.querySelectorAll('[data-modal-open]');
    this.closeTargets = document.querySelectorAll('[data-modal-close]');
    this.contentItems = document.querySelectorAll('[data-modal-content]');

    this.init();
  }

  init() {
    if (!this.container) return;

    // 開くボタンのイベント
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = trigger.dataset.modalOpen;
        this.open(targetId);
      });
    });

    // 閉じるボタン（オーバーレイ含む）のイベント
    this.closeTargets.forEach((target) => {
      target.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
    });

    // ESCキーで閉じる
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.container.classList.contains('is-active')) {
        this.close();
      }
    });
  }

  /**
   * モーダルを開く
   */
  open(targetId) {
    // 1. 全ての中身を非表示
    this.contentItems.forEach((item) => {
      item.style.display = 'none';
      item.classList.remove('is-active');
    });

    // 2. targetId に一致するコンテンツを表示
    const activeContent = Array.from(this.contentItems).find(
      (item) => item.dataset.modalContent === targetId
    );

    if (activeContent) {
      activeContent.style.display = 'block';
      activeContent.classList.add('is-active');

      // 3. 動画を再生
      const iframe = activeContent.querySelector('iframe');
      if (iframe) {
        this.playVideo(iframe);
      }
    }

    // 4. モーダル表示状態の変更（CSS transitionが発動）
    this.container.classList.add('is-active');
    this.container.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden'; // 背景スクロール固定
  }

  /**
   * モーダルを閉じる
   */
  close() {
    // 1. アクティブなモーダル内の iframe 動画を停止して先頭（0秒）に戻す
    const iframes = this.container.querySelectorAll('iframe');
    iframes.forEach((iframe) => {
      this.resetVideo(iframe);
    });

    // 2. モーダル非表示状態の変更
    this.container.classList.remove('is-active');
    this.container.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = ''; // 背景スクロール解除
  }

  /**
   * YouTube APIメッセージを送信して動画再生
   */
  playVideo(iframe) {
    iframe.contentWindow.postMessage(
      JSON.stringify({ event: 'command', func: 'playVideo', args: [] }),
      '*'
    );
  }

  /**
   * 動画を停止し、シークバーを 0 秒地点に戻す
   */
  resetVideo(iframe) {
    // 1. シークバーを 0 秒へ移動
    iframe.contentWindow.postMessage(
      JSON.stringify({ event: 'command', func: 'seekTo', args: [0, true] }),
      '*'
    );
    // 2. 動画を停止状態（一時停止）にする
    iframe.contentWindow.postMessage(
      JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }),
      '*'
    );
  }
}
